import { SvgIcon } from "@mui/material";

export default function PlusWhite(props) {
  return (
    <SvgIcon fontSize="small" width={15} height={15} viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M6.5 10V7.5H4C3.71875 7.5 3.5 7.28125 3.5 7C3.5 6.75 3.71875 6.5 4 6.5H6.5V4C6.5 3.75 6.71875 3.5 7 3.5C7.25 3.5 7.5 3.75 7.5 4V6.5H10C10.25 6.5 10.5 6.75 10.5 7C10.5 7.28125 10.25 7.5 10 7.5H7.5V10C7.5 10.2812 7.25 10.5 7 10.5C6.71875 10.5 6.5 10.2812 6.5 10ZM0 2C0 0.90625 0.875 0 2 0H12C13.0938 0 14 0.90625 14 2V12C14 13.125 13.0938 14 12 14H2C0.875 14 0 13.125 0 12V2ZM1 2V12C1 12.5625 1.4375 13 2 13H12C12.5312 13 13 12.5625 13 12V2C13 1.46875 12.5312 1 12 1H2C1.4375 1 1 1.46875 1 2Z"
        fill={props.htmlColor ? props.htmlColor : "#FFFFFF"}
      />
    </SvgIcon>
  );
}
